import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export const useStatsEvents = () => {
  const [state, setState] = useState({ events: null, eventId: "" });
  useEffect(() => {
    api.get("/stats/events").then((r) => setState({ events: r.data.events, eventId: r.data.default || "" })).catch(() => setState({ events: [], eventId: "" }));
  }, []);
  return [state.events, state.eventId, (eventId) => setState((s) => ({ ...s, eventId }))];
};

export const EventPicker = ({ events, value, onChange, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-full sm:w-80 bg-white" data-testid={testId}><SelectValue placeholder="Choose an event" /></SelectTrigger>
    <SelectContent>
      {events.map((e) => <SelectItem key={e.id} value={e.id} data-testid={`${testId}-${e.id}`}>{e.title}{e.date ? ` · ${e.date}` : ""}{e.archived ? " (archived)" : ""}</SelectItem>)}
    </SelectContent>
  </Select>
);
